
import * as defaultImport from "@splunk/dashboard-state";
export * from "@splunk/dashboard-state";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
